import { createContext } from 'react';

import { SoftwarePatch } from '@totem/components/devices/software-patches/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: SoftwarePatch[];
  action: string;
  actionItem: SoftwarePatch;
  onAction?: (action: string, item: SoftwarePatch) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
